import { Box, PseudoBox } from "@chakra-ui/core";

// TODO: Migrate to Chakra <List>
const List = (props) => <Box {...props} />;
List.defaultProps = {
  mb: 5,
  mt: 5,
};

export const Ul = ({ children, ...props }) => (
  <List as="ul" {...props}>
    {children}
  </List>
);

export const Ol = ({ children, ...props }) => (
  <List as="ol" {...props}>
    {children}
  </List>
);

export const Li = (props) => <PseudoBox {...props} as="li" />;
Li.defaultProps = {
  fontSize: "md",
  lineHeight: 24 / 16,
  mb: 3,
  color: "navy.500",
  _last: { mb: 0 },
};

export const UnstyledUl = (props) => (
  <Box as="ul" listStyleType="none" p={0} m={0} {...props} />
);
